import { channel } from './channel.ts';
import { comments } from './comments.ts';
import { feed } from './feed.ts';
import { gated } from './gated.ts';
import { hashtag } from './hashtag.ts';
import { history } from './history.ts';
import { listing } from './listing.ts';
import { login } from './login.ts';
import { playlist } from './playlist.ts';
import { playlists } from './playlists.ts';
import { problem } from './problem.ts';
import { queue } from './queue.ts';
import { richText } from './richText.ts';
import { resolve } from './resolve.ts';
import { search } from './search.ts';
import { settings } from './settings.ts';
import { shell } from './shell.ts';
import { sponsorBlock } from './sponsorBlock.ts';
import { subscriptions } from './subscriptions.ts';
import { tabs } from './tabs.ts';
import { watch } from './watch.ts';

/**
 * **English — the catalogue this build's `Strings` type is read from.**
 *
 * One section per area, and the sections are the app's own seams rather than a translator's: `problem`
 * is shared by every screen, `listing` by every grid, and the rest is one per screen directory. A
 * second language is `const de: Strings = { … }` in a sibling folder — `strings/de/` is that folder —
 * and the compiler enumerates what it is missing (`strings/index.ts`, whose `Widen` is what lets a
 * translation differ from these words at all).
 *
 * Two rules hold throughout, and both exist because breaking them produces a sentence no translator can
 * repair:
 *
 * - **An interpolated string is a function, never a template assembled by the caller.** Word order is
 *   not universal, so `` `${count} of ${total}` `` built at the call site is untranslatable by
 *   construction. Every value a sentence needs is a parameter here.
 * - **A count never picks its own noun.** `Formatters.countedNoun` takes `PluralForms` and asks
 *   `Intl.PluralRules` on the *number* — English fills in `one` and `other` and stops; a language with
 *   `few`/`many` fills those in too, and nothing at the call site changes.
 */
export const en = {
  channel,
  comments,
  feed,
  gated,
  hashtag,
  history,
  listing,
  login,
  playlist,
  playlists,
  problem,
  queue,
  richText,
  resolve,
  search,
  settings,
  shell,
  sponsorBlock,
  subscriptions,
  tabs,
  watch,
} as const;
